export async function applyPolyfills() {
  const polyfills: Promise<unknown>[] = [];
  if (!globalThis.URLPattern) polyfills.push(import("urlpattern-polyfill"));
  if (!("popover" in HTMLElement.prototype)) {
    polyfills.push(import("@oddbird/popover-polyfill"));
  }
  await Promise.all(polyfills);
}
